
// this is a custom implementation of delay to replace redux delay.
// this uses setTimeout which we are already overriding with hacktimer so the
// timers run in a service worker. Severice worker based timers are throttled
// less on ios devices so this helps resolve timing issues.
// src/customEffects.js
export function delay(ms, val = true) {
  return new Promise(resolve => setTimeout(() => resolve(val), ms));
}